import React, { ReactElement } from "react"
import { Link } from "gatsby"

function SideNav(): ReactElement {
  return (
    <nav>
      <div className="mb-8">
        <h5 className="side-nav-heading">Getting Started</h5>
        <ul>
          <li>
            <Link
              to="/getting-started/installation/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              Installation
            </Link>
          </li>
          <li>
            <Link
              to="/getting-started/first-validator/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              Create your first Validator
            </Link>
          </li>
          {/* <li>
            <Link
              to="/getting-started/release-notes/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              Release Notes
            </Link>
          </li> */}
        </ul>
      </div>
      <div className="mb-8">
        <h5 className="side-nav-heading">Building Validators</h5>
        <ul>
          <li>
            <Link
              to="/building/validator-builder/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              The ValidatorBuilder Class
            </Link>
          </li>
          <li>
            <Link
              to="/building/chaining-functions/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              Chaining Functions
            </Link>
          </li>
          <li>
            <Link
              to="/building/conditional-functions/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              Conditional Functions
            </Link>
          </li>
          <li>
            <Link
              to="/building/custom-functions/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              Custom Functions
            </Link>
          </li>
          <li>
            <Link
              to="/building/including-validators/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              Including Validators
            </Link>
          </li>
          <li>
            <Link
              to="/building/for-function/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              <em>For</em> Function
            </Link>
          </li>
          <li>
            <Link
              to="/building/keys-and-messages/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              Keys and Messages
            </Link>
          </li>
        </ul>
      </div>
      <div className="mb-8">
        <h5 className="side-nav-heading">Functions</h5>
        <ul>
          <li>
            <Link
              to="/functions/common/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              Common
            </Link>
          </li>

          <li>
            <Link
              to="/functions/comparison/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              Comparison
            </Link>
          </li>
          <li>
            <Link
              to="/functions/string/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              String
            </Link>
          </li>
          <li>
            <Link
              to="/functions/boolean/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              Boolean
            </Link>
          </li>
          <li>
            <Link
              to="/functions/collection/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              Collection
            </Link>
          </li>
          <li>
            <Link
              to="/functions/utility/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              Utility
            </Link>
          </li>
        </ul>
      </div>
      <div className="mb-8">
        <h5 className="side-nav-heading">Validation</h5>
        <ul>
          <li>
            <Link
              to="/validation/execution/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              Executing a Validator
            </Link>
          </li>
          <li>
            <Link
              to="/validation/options/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              Validation Options
            </Link>
          </li>
          <li>
            <Link
              to="/validation/results/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              Validation Results
            </Link>
          </li>
        </ul>
      </div>
      <div>
        <h5 className="side-nav-heading">Advanced</h5>
        <ul>
          <li>
            <Link
              to="/advanced/extension-methods/"
              className="side-nav-link"
              activeClassName="side-nav-link-active"
            >
              Extending IValidatorBuilder
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  )
}

export default SideNav
